export const FORMAT_DATE = 'DD-MM-YYYY'
export const FORMAT_DATE_HOURS = 'YYYY-MM-DD HH:mm:ss'
export const DBOARD_FORMATSTART = 'YYYY-MM-DD 00:00:00'
export const DBOARD_FORMATEND = 'YYYY-MM-DD 23:59:59'
